import { payCheckout, payPayWidget } from 'services/checkout-service/checkout';
import { CheckoutPayResponse, CustomerRequest, Source } from 'services/checkout-service/models';

export const useCloverPay = () => {

  const payWithSources = async (sources: Source[], isInvoicePayment: boolean, isPayWidget: boolean, checkoutSessionId?: Uuid, total?: number, orderNote?: string, customer?: Partial<CustomerRequest>, recaptchaToken?: string) => {
    if (isPayWidget) return await payPayWidget(sources, checkoutSessionId, total, orderNote, customer, recaptchaToken);

    // Paying for a hosted checkout (not invoice) allows customer creation.
    return isInvoicePayment
      ? await payCheckout(sources, checkoutSessionId, orderNote, undefined, recaptchaToken)
      : await payCheckout(sources, checkoutSessionId, orderNote, customer, recaptchaToken);
  }

  const tokenize = async (cloverInstance: Clover, isAch = false, isGiftCard=false, tokenizationOptions?: Clover.AchTokenRequestOptions) => {
    try {
      if (isGiftCard) {
        return await cloverInstance.createGiftCardToken(tokenizationOptions);
      }

      return (isAch && tokenizationOptions) ? await cloverInstance.createAchToken(tokenizationOptions) : await cloverInstance.createToken();
    } catch (e) {
      console.error('Payment token could not be created', e);
      throw new Error(e);
    }
  };

  const pay = async (
    isInvoicePayment: boolean,
    isPayWidget: boolean,
    sources: Source[],
    checkoutSessionId?: Uuid,
    customer?: Partial<CustomerRequest>,
    total?: number,
    orderNote?: string,
    recaptchaToken?: string,
  ): Promise<CheckoutPayResponse> => {
    try {
      return payWithSources(sources, isInvoicePayment, isPayWidget, checkoutSessionId, total, orderNote, customer, recaptchaToken);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('Error in pay');
      console.error('Payment unsuccessful', e);
      throw e;
    }
  };

  return {
    tokenize,
    pay
  };
};
